/*
Duplicate file server/booking-cancellation-options.js
*/
export default {
  never: {
    name: 'Never',
    option: 'never',
  },
  anytime: {
    name: 'Anytime',
    option: 'anytime',
  },
  specified: {
    name: ['Up to', 'before their appointment'],
    option: 'specified',
  },
};
